import React from 'react';

interface Props {
    className: string;
    onClick?: () => void;
}
export default class SidebarHeading extends React.PureComponent<Props, {}> {
    static defaultProps = {
        className: '',
    };

    handleClick = (evt: React.MouseEvent): void => {
        const { onClick } = this.props;

        if (onClick) {
            onClick();
        }
    };

    render() {
        const { children, className } = this.props;

        let classNames: Array<string> = ['ct-sidebar__heading'];
        if (className) {
            classNames.push(className);
        }

        return (
            <div role="heading" aria-level={1} className={classNames.join(' ')} onClick={this.handleClick}>
                {children}
            </div>
        );
    }
}
